export const CONFIG = {
  API_URL: 'https://github-user-languages.herokuapp.com'
}
